import React, { useState, useEffect, useRef } from "react";
import "../../../../../../../css/workspace.css";
import $ from "jquery";
import * as types from "../../../../../../../redux/constants/collectionConstants";
import useDrivePicker from 'react-google-drive-picker';

import {
  uploadSharepointData,
  uploadDocumentV2,
  uploadDocumentV2AzureService,
  uploadUrlV2,
  getTrainedDataV2,
  deleteTrainedDataV2,
  sendInputAnswerV2,
  getDocUploadStatusV2,
  deleteDocumentV2,
  getWalkthroughs,
  uploadGoogleDriveData,
  uploadGoogleDriveDataV2
} from "../../../../../../../redux/actions/collectionsV2";
import { connect, useSelector, useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import {
  Button,
  Tabs,
  Avatar,
  Card,
  Popover,
  Checkbox,
  Tooltip,
  Input,
  Upload,
  Table,
  Tag,
  Space,
  Select,
  Image,
  Radio,
  Modal,
} from "antd";
import {
  AppstoreOutlined,
  FileTextOutlined,
  LinkOutlined,
  InfoCircleOutlined,
  PlusCircleOutlined,
  FileAddOutlined,
  CloseCircleTwoTone,
  DeleteTwoTone,
  ExportOutlined,
  FullscreenExitOutlined,
  EditOutlined,
  DeleteOutlined,
  PlusOutlined,
  TagsOutlined,
  CheckCircleOutlined,
  PlayCircleOutlined,
  StopOutlined,
  GlobalOutlined,
  PauseCircleOutlined,
  FontSizeOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import  {PublicClientApplication}  from '@azure/msal-browser'

import { notify } from "../../../../../../../components/Snack";
import gdriveIcon from "../../../../../../../images/workspace/gdrive.svg";
import sharepointIcon from "../../../../../../../images/workspace/sharepoint.svg";
import checkListIcon from "../../../../../../../images/svg-icons/checkbox-circle-line.svg";
import folderListIcon from "../../../../../../../images/svg-icons/folder-open-line.svg";
import fileListIcon from "../../../../../../../images/svg-icons/file-list-3-line.svg";
import fileBackIcon from "../../../../../../../images/svg-icons/arrow-left-line.svg";

const msalConfig = {
  auth: {
    clientId: process.env?.REACT_APP_SHAREPOINT_CLIENT_ID,
    authority: process.env?.REACT_APP_SHAREPOINT_AUTHORITY,
    redirectUri: process.env?.REACT_APP_WEB_APP_URL
  },
};
const msalInstance = new PublicClientApplication(msalConfig);

const init1 = async () => {
  try {
    await msalInstance.initialize();
  } catch (error) {
    console.error('Initialization failed:', error);
  }
}


const onSearchFile = (value, _e, info) => console.log(info?.source, value);


const AddLocalFile = () => {
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [filePath, setFilePath] = useState("");
  const [uploadFileListTemp, setUploadFileListTemp] = useState([]);
  const [docURL, setDocURL] = useState("");
  const [ocrFlag, setOcrFlag] = useState("false");
  const [docsList, setDocsList] = useState([]);
  const [sharepointLoggedIn, setSharepointLoggedIn] = useState(false);

  useEffect(() => {
    init1();
  }, []);

  const { Search } = Input;

  const [isFolderModalOpen,setFolderModal] = useState(false)
  const [token, setToken] = useState('')
  const [folders, setFolders] = useState([]);
  const [folderId,setFolderId] = useState([])
  const [goBack, isGoBack] = useState(false)
  const [selectFolder, setSelectedFolders] = useState([])
  const [driveFolderSelected, setDriveFolderSelected] = useState(true);

  const dispatch = useDispatch();
  const queryParams = useLocation().search;

  const collectionName = new URLSearchParams(queryParams).get("name");

  const groupPlan = useSelector((state) => state.userReducer.groupPlan);
  let planType;
  if (groupPlan?.planId == 4) {
    planType = "team";
  } else if (groupPlan?.planId == 5) {
    planType = "business";
  } else {
    planType = "pro";
  }

  const collectionSource = useSelector(
    (state) => state.collectionReducer.collectionSource
  );

  const documentsList = useSelector(
    (state) => state.collectionReducer.collectionDocs
  );
  
  const userDetails = useSelector(
      (state) => state?.organizationReducer?.currentOrganization
    );
  const viewOnly = userDetails?.role_id === "1" ? true : false;

  const handleSelectFolderV2 = (data,isSet) => {
    if (!isSet) {
      if (folders.length <= 2) return
      if (selectFolder.some(obj => obj.id == data.id)) {
        setSelectedFolders(prev => prev.filter(obj => obj.id !== data.id));
        return
      } 
      if (data?.file) {
          setSelectedFolders(prev => [...prev,{id:data.id,url:data['@microsoft.graph.downloadUrl'],file_name:data.name,source_url:data.webUrl,size:data.size}])
      }
      else {
        setSelectedFolders(prev => [...prev,{id:data.id}])
      }
    } else {
      setFolderId(prev=>[...prev,data.id])
      setSelectedFolders([])
    }
  }

  const dummyShare = () => {
    setFolderModal(false)
    setFolderId([])
    setFolders([])
    setSelectedFolders([])
    setLoading(false)
  }

  useEffect(()=>{
    
    if (goBack){
        isGoBack(false)
        return
    }
    if (folderId.length == 1) {
        showAllDrives()
    }
    else if ( folderId.length == 2) {
        fetchDocuments(folderId[1])
    } else if ( folderId.length > 2 ) {
        fetchDocuments(folderId[1],folderId[folderId.length - 1])
    } 

  },[folderId])

  const fetchDocuments = async ( driveId,folderId) => {
    let response
    if (!folderId) {
        response = await fetch(`https://graph.microsoft.com/v1.0/drives/${driveId}/root/children`, {
          method: 'GET',
          headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json',
          },
      });
    }
    else {
      response = await fetch(`https://graph.microsoft.com/v1.0/drives/${driveId}/items/${folderId}/children`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
    });
    }

    if (!response.ok) {
        throw new Error('Failed to fetch documents');
    }

    const data = await response.json();
    const newArray = data.value;
    setFolders(prev => [...prev,newArray]);
    return data.value; 
  };

  const uniqueDocuments = (arr) => {
    const seen = new Map();

    arr.forEach((doc) => {
      const { document_name, status } = doc;
      // If the document name is not in the map, add it
      if (!seen.has(document_name)) {
        seen.set(document_name, doc);
      } else {
        // If it exists, check the status
        if (status === "success") {
          // If the new doc has status success, replace the existing one
          seen.set(document_name, doc);
        }
      }
    });
    // Convert the map back to an array
    return Array.from(seen.values());
  };

  useEffect(() => {
    setDocsList(documentsList);
  }, [documentsList]);

  useEffect(() => {
    if (docsList?.length > 0) {
      const result = uniqueDocuments(docsList);
      dispatch({
        type: types.UPDATE_COLLECTION_DOCS_LIST,
        collectionDocs: result,
      });
    }
  }, [docsList]);

  const props = {
    onChange(info) {
      setFilePath(info.file.name);

      const objectList = {
        id: 1,
        name: info.file.name,
        originFileObj: info.file,
        size: info.file.size,
        docURL: "",
      };
      uploadFileListTemp?.push(objectList);
    },
  };

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://apis.google.com/js/api.js';
    script.async = true;
    document.body.appendChild(script);
  }, []);
  const [openPicker] = useDrivePicker();
  const [fileTypes, setFileTypes] = useState("");

  const [modalGdriveData, setModalGdriveData] = useState(null);
  const [modalGdriveToken, setModalGdriveToken] = useState(null);

  const handleOpenPicker = () => {
    window.gapi.load('client:auth2', () => {
      window.gapi.client
        .init({
          apiKey: process.env.REACT_APP_GOOGLE_DRIVE_API_KEY,
        })
        .then(() => {
          let tokenInfo = window.gapi.auth.getToken();
          const pickerConfig = {
            clientId: process.env.REACT_APP_GOOGLE_DRIVE_CLIENT_ID,
            developerKey: process.env.REACT_APP_GOOGLE_DRIVE_API_KEY,
            viewId: 'FOLDERS',
            viewMimeTypes: '.docx',
            token: tokenInfo ? tokenInfo.access_token : null,
            showUploadView: false,
            showUploadFolders: false,
            supportDrives: true,
            multiselect: true,
            setSelectFolderEnabled: true,
            callbackFunction: async (data) => {
              const elements = Array.from(
                document.getElementsByClassName('picker-dialog')
              );
              elements.forEach(element => {
                element.style.zIndex = '2000';
              });
              if (data.action === 'picked') {
                if (!tokenInfo) {
                  tokenInfo = window.gapi.auth.getToken();
                }
                const fetchOptions = {
                  headers: {
                    Authorization: `Bearer ${tokenInfo.access_token}`,
                  },
                };
                
                const validFileTypes = [
                  "xlsx",
                  "docx",
                  "pdf",
                  "pptx",
                  "mp3",
                  "mp4",
                  "wav",
                  "m4a",
                  "mpeg",
                  "flac",
                ];
                if (data.docs.length == 1 && data.docs[0].type === 'folder') {
                  if ( !fileTypes.length ) {
                    setLoading(false)
                    dispatch(
                      notify(
                        "error",
                        "Please select file types"
                      )
                    );
                    return
                  }
                  
                  try {
                    setIsFolderSelected(true);
                    setModalGdriveData(data);
                    setModalGdriveToken(tokenInfo);
                    
                  } catch (error) {
                    setLoading(false)
                    if (error?.message) {
                      dispatch(
                        notify(
                          "error",
                          `Please upload files with size less than ${error.message} MB`
                        )
                      );
                    } else {
                      dispatch(
                        notify(
                          "error",
                          "Something went wrong, please refresh the page"
                        )
                      );
                    }
                  } 
                }
                else {
                  for (const file of data.docs) {
                    const fileExt = file.name.substring(file.name.lastIndexOf('.')+1)
                    if (!validFileTypes.includes(fileExt)) {
                      dispatch(
                        notify(
                          "error",
                          "Please upload a valid file type: *.pptx, *.docx, *.xlsx, *.pdf "
                        )
                      );
                      console.log("Files format is not supported please select .docx,xlsx,pptx,.pdf")
                      return
                    }
                    file.extension = fileExt
                  }
                  try {
                    setLoading(true)
                    const fileDataInfo = data.docs.map((file) => {
                      if ((file.extension == 'xlsx') && (file?.sizeBytes / 1024 /1024) >= 10) {
                        throw new Error(`10`)
                      } else if (validFileTypes.slice(1,4).includes(file.extension) && (file?.sizeBytes / 1024 /1024) >= 64) {
                        throw new Error(`64`)
                      } else if (validFileTypes.slice(5).includes(file.extension) && (file?.sizeBytes / 1024 /1024) >= 24) {
                        throw new Error(`24`)
                      }
                      setDocsList((prevArray) => [
                      ...prevArray,
                      {
                        document_name: file.name,
                        status: "in-progress",
                        text_data: null,
                      },
                    ]);
                      return {id:file.id,file_name:file.name}
                    })
                    const createResponse = await uploadGoogleDriveData(collectionName,planType,fileDataInfo,tokenInfo.access_token,"gdrive")
                    setLoading(false)
                    if (createResponse?.data?.status == "OK") {
                      dispatch(
                        notify("success",
                          "Your request is being processed and may take a few moments. Please revisit this page shortly to check the latest status."
                        )
                      );
                    } else {
                      dispatch(
                        notify("error", "Something went wrong. Please try again")
                      );
                    }
                  } catch (error) {
                    setLoading(false)
                    if (error?.message) {
                      dispatch(
                        notify(
                          "error",
                          `Please upload files with size less than ${error.message} MB`
                        )
                      );
                    } else {
                      dispatch(
                        notify(
                          "error",
                          "Something went wrong, please refresh the page"
                        )
                      );
                    }
                  } 
                }
              }
            },
          };
          openPicker(pickerConfig);
        
        });
    });
  };

  const showAllDrives = async () => {
    if (token != '') {
        const response = await fetch(`https://graph.microsoft.com/v1.0/sites/${folderId[0]}/drives`, {
          headers: {
            Authorization:`Bearer ${token}`
          }
        })
        const data = await response.json();
        const drives = data.value
        setFolders(prev => [...prev,drives]);
    }
  }

  const fetchAllSitesV2 = async (accessToken) => {
    const response = await fetch('https://graph.microsoft.com/v1.0/sites?search=*', {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  
    if (!response.ok) {
      throw new Error('Failed to fetch sites');
    }
  
    const data = await response.json();
    return data.value; 
  };

  const handleSharePoint = async () => {
    try {
      const tokenResponse = await msalInstance.loginPopup({
        scopes: ['Files.Read', 'Sites.Read.All']
      });
      const accessToken = tokenResponse.accessToken;
      setToken(accessToken)
      const resp_sites = await fetchAllSitesV2(accessToken)
      setSharepointLoggedIn(true);
      setFolders(prev => [...prev,resp_sites])
      setFolderModal(true)
    } catch (error) {
      console.error('Error selecting files:', error);
    }
  }

  const addFile = async () => {
    setIsLoading(true);
    try {
      const result = await dispatch(getWalkthroughs(collectionName));
      const documentsList = result?.message?.document_names;

      if (uploadFileListTemp?.length > 0) {
        uploadFileListTemp?.map(async (uploadFileData, ind) => {
          if (filePath?.length > 0) {
            const docFileTypeArray = uploadFileData?.name?.split(".");
            const fileName = uploadFileData?.name;
            const baseFileName = fileName.substring(
              0,
              fileName.lastIndexOf(".")
            );
            const docFileType = docFileTypeArray[docFileTypeArray?.length - 1];
            const validFileTypes = [
              "pptx",
              "docx",
              "xlsx",
              "pdf",
              "pptx",
              "mp3",
              "mp4",
              "wav",
              "m4a",
              "mpeg",
              "flac",
              ".eml",
              ".msg"
            ];

            //const docURL = uploadFileData?.docURL;
            if (docURL?.length > 0) {
              if (
                !(docURL.startsWith("http://") || docURL.startsWith("https://"))
              ) {
                dispatch(
                  notify("error", "Please enter a valid Reference Document URL")
                );
                setIsLoading(false);
                return;
              }
            }

            const baseFileNames = documentsList.map((doc) =>
              doc?.document_name.substring(
                0,
                doc?.document_name.lastIndexOf(".")
              )
            );
            // if (baseFileNames.includes(baseFileName)) {
            //   dispatch(
            //     notify(
            //       "error",
            //       "Filename already exist. Please remove the existing file and upload the new file or rename the new file."
            //     )
            //   );
            //   setIsLoading(false);
            //   return;
            // }

            if (validFileTypes.includes(docFileType)) {
              const fileSize = uploadFileData?.size;
              const fileMb = fileSize / 1024 / 1024;
              const fileLength = 64;
              let specificFileSizeLimit = 64;
              if (
                ["mp3", "mp4", "wav", "m4a", "mpeg", "flac"].includes(
                  docFileType
                )
              ) {
                specificFileSizeLimit = 24;
              } else if (["xlsx"].includes(docFileType)) {
                specificFileSizeLimit = 10;
              }
              if (uploadFileData?.name?.length <= fileLength) {
                if (fileMb <= specificFileSizeLimit) {
                  setIsLoading(true);

                  setDocsList((prevArray) => [
                    ...prevArray,
                    {
                      document_name: uploadFileData?.name,
                      status: "in-progress",
                      text_data: null,
                    },
                  ]);

                  let createResponse;

                  if (ocrFlag == "false" && docFileType != "xlsx") {
                    dispatch(
                      notify(
                        "success",
                        "The file upload is in progress, and the status will be updated soon. You may navigate away or upload another file."
                      )
                    );

                    setIsLoading(false);
                    setFilePath("");
                    setDocURL("");

                    createResponse = await uploadDocumentV2AzureService(
                      collectionName,
                      uploadFileData?.originFileObj,
                      planType,
                      docURL,
                      ocrFlag
                    );

                    if (createResponse?.data?.status == "OK") {
                      dispatch(
                        notify("success", "Document uploaded successfully")
                      );
                      setDocsList((prevArray) => [
                        ...prevArray,
                        {
                          document_name: uploadFileData?.name,
                          status: "success",
                          text_data: null,
                        },
                      ]);
                    } else {
                      dispatch(
                        notify(
                          "error",
                          "Something went wrong. Please try again"
                        )
                      );
                    }
                  } else {
                    dispatch(
                      notify(
                        "success",
                        "The file upload is in progress, and the status will be updated soon. You may navigate away or upload another file."
                      )
                    );
                    createResponse = await uploadDocumentV2(
                      collectionName,
                      uploadFileData?.originFileObj,
                      planType,
                      docURL,
                      ocrFlag
                    );
                  }

                  if (createResponse?.data == "OK") {
                    let timer = setInterval(async () => {
                      const docUploadResponse = await getDocUploadStatusV2(
                        uploadFileData?.name,
                        collectionName,
                        planType
                      );

                      if (
                        !docUploadResponse?.status ||
                        docUploadResponse?.status == "NoRecord"
                      ) {
                        setIsLoading(false);
                        clearInterval(timer);
                        dispatch(
                          notify(
                            "error",
                            "Something went wrong, please refresh the page"
                          )
                        );
                      } else if (docUploadResponse?.status == "success") {
                        setDocsList((prevArray) => [
                          ...prevArray,
                          {
                            document_name: uploadFileData?.name,
                            status: "success",
                            text_data: null,
                          },
                        ]);

                        setIsLoading(false);
                        clearInterval(timer);

                        dispatch(
                          notify(
                            "success",
                            "Document is vectorized and stored!"
                          )
                        );
                        setFilePath("");
                        setDocURL("");
                      } else if (docUploadResponse?.status == "failed") {
                        clearInterval(timer);
                        dispatch(notify("error", "Document upload failed"));
                      }
                    }, 5000);
                  } else {
                    if (createResponse?.data?.status == "OK") {
                      dispatch(
                        notify("success", "Document uploaded successfully")
                      );
                    } else {
                      dispatch(notify("error", createResponse?.data?.message));
                    }
                  }
                } else {
                  setIsLoading(false);
                  dispatch(
                    notify(
                      "error",
                      `Please upload a file with size less than ${specificFileSizeLimit} MB`
                    )
                  );
                }
              } else {
                dispatch(
                  notify(
                    "error",
                    `File name should be less than ${fileLength} characters`
                  )
                );
              }
            } else {
              dispatch(
                notify(
                  "error",
                  "Please upload a valid file type: *.pptx, *.docx, *.xlsx, *.pdf "
                )
              );
              setIsLoading(false);
            }
          } else {
            dispatch(notify("error", "Please select a file to upload "));
            setIsLoading(false);
          }
        });
      } else {
        dispatch(notify("error", "Please select atleast a file to upload "));
        setIsLoading(false);
      }
    } catch (err) {
      dispatch(
        notify("error", "Something went wrong, please refresh the page")
      );
      setIsLoading(false);
      console.log("Error while retrieving", err.message);
    }
    // setUploadRowNumber(1);
  };

  const onDocumentURLClick = async (value) => {
    setDocURL(value);
  };

  const [fileMode, setFileMode] = useState("local");
  const [isFolderSelected, setIsFolderSelected] = useState(false);
  const validFileTypes = [
    "xlsx",
    "docx",
    "pdf",
    "pptx",
    "mp3",
    "mp4",
    "wav",
    "m4a",
    "mpeg",
    "flac",
  ]

  const handleCancelOld = () => {
    setIsFolderSelected(false);
    dummyShare();
  };

  const handleGdriveOnOK= async () => {
   await uploadGdriveFolder(modalGdriveData, modalGdriveToken);
   setIsFolderSelected(false);
  };

  const uploadGdriveFolder = async (data, tokenInfo) => {
    setDriveFolderSelected(true);
                    const folderId = data.docs[0].id;
                    setLoading(true)
                    const filesResponse = await fetch(`https://www.googleapis.com/drive/v3/files?q='${folderId}' in parents&key=a`, {
                        headers: {
                            Authorization: `Bearer ${tokenInfo.access_token}`,
                        },
                    });
                    const filesData = await filesResponse.json();
                    let files = filesData.files || [];
                    files = files.filter(fileName => fileTypes.includes(fileName.name.substring(fileName.name.lastIndexOf('.'))))
                    const fileDataInfo = files.map((file) => {
                      const fileExt = file.name.substring(file.name.lastIndexOf('.'))
                      if ((fileExt == 'xlsx') && (file?.sizeBytes / 1024 /1024) >= 10) {
                        throw new Error(`10`)
                      } else if (validFileTypes.slice(1,4).includes(fileExt) && (file?.sizeBytes / 1024 /1024) >= 64) {
                        throw new Error(`64`)
                      } else if (validFileTypes.slice(5).includes(fileExt) && (file?.sizeBytes / 1024 /1024) >= 24) {
                        throw new Error(`24`)
                      }
                      setDocsList((prevArray) => [
                        ...prevArray,
                        {
                          document_name: file.name,
                          status: "in-progress",
                          text_data: null,
                        },
                      ]);
                      return {id:file.id,file_name:file.name}
                    })
                    const createResponse = await uploadGoogleDriveData(collectionName,planType,fileDataInfo,tokenInfo.access_token,"gdrive")
                    setLoading(false)
                    if (createResponse?.data?.status == "OK") {
                      dispatch(
                        notify("success",
                          "Your request is being processed and may take a few moments. Please revisit this page shortly to check the latest status."
                        )
                      );
                    //   const newDocList = createResponse.data.message.map(docName => ({
                    //     document_name: docName,
                    //     status: "success",
                    // }));
                    
                    // setDocList(newDocList);
                    // setDocListTemp(docList);
                    } else {
                      dispatch(
                        notify("error", "Something went wrong. Please try again")
                      );
                    }
  };


  const uploadSharepointFolder = async () => {
    let files = await fetchDocuments(folderId[1],selectFolder[0].id)
      files = files.filter(fileName => fileTypes.includes(fileName.name.substring(fileName.name.lastIndexOf('.'))))
      for (const file of files) {
        const fileExt = file?.name?.substring(file.name.lastIndexOf('.')+1)
        if (!fileExt || !validFileTypes.includes(fileExt)) {
          dispatch(
            notify(
              "error",
              "Please upload a valid file type: *.pptx, *.docx, *.xlsx, *.pdf "
            )
          );
          console.log("Files format is not supported please select .docx,xlsx,pptx,.pdf")
          dummyShare()
          return
        }
        file.extension = fileExt
      }
      try {
        setLoading(true)
        const fileDataArray = files.map((file) => {
          if ((file.extension == 'xlsx') && (file.size / 1024 /1024) >= 10) {
            throw new Error(`10`)
          } else if (validFileTypes.slice(1,4).includes(file.extension) && (file.size / 1024 /1024) >= 64) {
            throw new Error(`64`)
          } else if (validFileTypes.slice(5).includes(file.extension) && (file.size / 1024 /1024) >= 24) {
            throw new Error(`24`)
          }
          return { url: file['@microsoft.graph.downloadUrl'], file_name:file.name,source_url:file.webUrl };
        })
        dispatch(
          notify(
            "success",
            "The file upload is in progress, and the status will be updated soon. You may navigate away or upload another file."
          )
        );
        const createResponse = await uploadSharepointData(collectionName,JSON.stringify(fileDataArray),"sharepoint",planType)
        setLoading(false)
        if (createResponse?.data?.status == "OK") {
          dispatch(
            notify("success", "Document uploaded successfully")
          );
          // const updatedDocList = [
          //   ...docList, 
          //   ...fileDataArray.map(file => ({
          //     document_name: file.file_name,
          //     status: "success"
          //   }))
          // ];
          
          // setDocList(updatedDocList);
          // setDocListTemp(docList);
        } else {
          dispatch(
            notify("error", "Something went wrong. Please try again")
          );
        }
        setLoading(false)
      } catch (error) {
        setLoading(false)
        if (error?.message) {
          dispatch(
            notify(
              "error",
              `Please upload files with size less than ${error.message} MB`
            )
          );
        } else {
          dispatch(
            notify(
              "error",
              "Something went wrong, please refresh the page"
            )
          );
        }
      }
      setIsFolderSelected(false)
      dummyShare();
  };

  const sendSelectedSharePointData = async () => {
    
    setFolderModal(false)
    if (selectFolder.length == 1 && !selectFolder[0]?.url) {
      if ( !fileTypes.length ) {
        setLoading(false)
        dispatch(
          notify(
            "error",
            "Please select file types"
          )
        );
        dummyShare()
        return
      }
      setIsFolderSelected(true);
      
      
    } else {
    
      for (const file of selectFolder) {
        const fileExt = file?.file_name?.substring(file.file_name.lastIndexOf('.')+1)
        if (!fileExt || !validFileTypes.includes(fileExt)) {
          dispatch(
            notify(
              "error",
              "Please upload a valid file type: *.pptx, *.docx, *.xlsx, *.pdf "
            )
          );
          console.log("Files format is not supported please select .docx,xlsx,pptx,.pdf")
          dummyShare()
          return
        }
        file.extension = fileExt
      }
      try {
        setLoading(true)
        let fileName;

        const fileDataArray = selectFolder.map((file) => {
          if ((file.extension == 'xlsx') && (file.size / 1024 /1024) >= 10) {
            throw new Error(`10`)
          } else if (validFileTypes.slice(1,4).includes(file.extension) && (file.size / 1024 /1024) >= 64) {
            throw new Error(`64`)
          } else if (validFileTypes.slice(5).includes(file.extension) && (file.size / 1024 /1024) >= 24) {
            throw new Error(`24`)
          }

          fileName = file.file_name;
          setDocsList((prevArray) => [
            ...prevArray,
            {
              document_name: file.file_name,
              status: "in-progress",
              text_data: null,
            },
          ]);

          return { url: file.url, file_name:file.file_name,source_url:file.source_url };
        })
        dispatch(
          notify(
            "success",
            "The file upload is in progress, and the status will be updated soon. You may navigate away or upload another file."
          )
        );
        const createResponse = await uploadSharepointData(collectionName,JSON.stringify(fileDataArray),"sharepoint",planType)
        setLoading(false)
        if (createResponse?.data?.status == "OK") {
          setDocsList((prevArray) => [
            ...prevArray,
            {
              document_name: fileName,
              status: "success",
              text_data: null,
            },
          ]);
          dispatch(
            notify("success", "Document uploaded successfully")
          );
          
        } else {
          dispatch(
            notify("error", "Something went wrong. Please try again")
          );
        }
        setLoading(false)
      } catch (error) {
        setLoading(false)
        if (error?.message) {
          dispatch(
            notify(
              "error",
              `Please upload files with size less than ${error.message} MB`
            )
          );
        } else {
          dispatch(
            notify(
              "error",
              "Something went wrong, please refresh the page"
            )
          );
        }
      }
      dummyShare();
    }
  }

  const handleBack = () => {
    isGoBack(true)
    setFolders(prev => {
      const newAr = prev.slice(0,-1);
      return newAr
    })
    setFolderId(prev => prev.slice(0,-1)) 
    setSelectedFolders([])
  }

  const [fileTypeDefault, setFileTypeDefault] = useState([]);
  const handleChangeFileType = (value) => {
    setFileTypeDefault(value);
    let fileTypesList = `["${value}"]`;
    fileTypesList = fileTypesList.replaceAll(",", `","`);
    setFileTypes(fileTypesList);
  };

  const checkForActiveSharepointSession = () => {
    const accounts = msalInstance.getAllAccounts();
    accounts.length == 0 ? setSharepointLoggedIn(false) : setSharepointLoggedIn(true);
  }

  return (
    <>
    <Modal
        title="Upload confirmation"
        open={isFolderSelected}
        onOk={fileMode === "gdrive" ? handleGdriveOnOK : uploadSharepointFolder}
        onCancel={handleCancelOld}
      >
        <p>Are you sure you want to upload all the files from the selected folder?</p>
      </Modal>
    
      <div className="ms-auth-block upload-box">
        <div className="wk-upload-menu">

        <Modal className="file-list-modal" title="Select Files/Folder" open={isFolderModalOpen} onOk={sendSelectedSharePointData} onCancel={dummyShare} style={{top:'20px'}}>
                                  <div className="file-header">
                                    {folders?.length > 1 &&<div className="icon-back" onClick={handleBack}>
                                      <Button> <img style={{width: '25px'}} src={fileBackIcon}/> </Button>
                                    </div>}
                                    <div className="search-file">
                                    <Search
                                      placeholder="input search text"
                                      allowClear
                                      enterButton="Search"
                                      onSearch={onSearchFile}
                                    />
                                    </div>
                                  </div>
                                  <p style={{color: 'red'}}>Double-click on a folder name to open and view its contents</p>
                                  <div className="scrollable scroll-modal" style={{ maxHeight: "50dvh", overflowY: "auto" }}>
                                    {folders.length != 0 && folders[folders.length-1].map((folder) => (
                                      <div className="fl-list-item" key={folder.id} onClick={() => handleSelectFolderV2(folder)} onDoubleClick={() => handleSelectFolderV2(folder,true)}>
                                        
                                        <div className={selectFolder.some(obj => obj.id == folder.id) ? "img-text-file active" : "img-text-file"}>
                                          <div className="img-text-left" >
                                            <span>{folder?.file ? <img src={fileListIcon} /> : <img src={folderListIcon} />}</span>
                                            <p>{folder.displayName ? folder.displayName : folder.name}</p>
                                          </div>                                          
                                          {folders.length > 2 && <div className={selectFolder.some(obj => obj.id == folder.id) ? "check-btn active" : "check-btn"}>
                                            <img src={checkListIcon} alt="" />
                                          </div>}
                                        </div>
                                      </div>
                                    ))}
                                  </div>                                    
                                  </Modal>

          <ul>
            <li onClick={(e)=>{setFileMode("local")}} className={`${fileMode === "local" ? "active" : ""}`}>Local Files</li>
            <li onClick={(e)=>{setFileMode("gdrive")}} className={`${fileMode === "gdrive" ? "active" : ""}`}>Google Drive</li>
            <li onClick={(e)=>{
              setFileMode("sharepoint");
              checkForActiveSharepointSession();
            }} className={`${fileMode === "sharepoint" ? "active" : ""}`}>SharePoint</li>
          </ul>
        </div>
        {fileMode === "local" ? (
        <div className="local-files">
          <div
            className="flex-title-btn"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div className="checkbox-ocr">
              <Checkbox
                className={`${
                  collectionSource === "database" || viewOnly ? "disabled" : ""
                }`}
                style={{
                  pointerEvents:
                    collectionSource === "database" || viewOnly ? "none" : "auto",
                }}
                onClick={(e) => setOcrFlag(e.target.checked ? "true" : "false")}
              >
                Use OCR &nbsp;
                <Tooltip title="Check the box only if your PDF file is a scanned document">
                  <InfoCircleOutlined />
                </Tooltip>
              </Checkbox>
            </div>
            {/* <div className="btn-flex">
              {isLoading ? (
              <button className="btn btn-primary">
                <div class="sp sp-circle text-light"></div>
              </button>
            ) : (
              <>
                <Button icon={<PlusCircleOutlined />} size="small">
                  {" "}
                  Add New file
                </Button>
                <Button type="primary" size="small"
                  onClick={(e) => addFile()}
                >
                  Save
                </Button>
                </> 
            )}
              </div> */}
          </div>
          <div className="img-selector">
            <div className="upbox-flex-items-full">
              <div className="upf-item">
                <Upload
                  //className="upload-list-block"
                  className={`${
                    collectionSource === "database" || viewOnly
                      ? "disabled"
                      : "upload-list-block"
                  }`}
                  style={{
                    pointerEvents:
                      collectionSource === "database" || viewOnly? "none" : "auto",
                  }}
                  {...props}
                  beforeUpload={() => false}
                  disabled={collectionSource === "database" || viewOnly}
                >
                  <Button
                    className={`${
                      collectionSource === "database" || viewOnly ? "disabled" : ""
                    }`}
                    style={{
                      pointerEvents:
                        collectionSource === "database" || viewOnly ? "none" : "auto",
                    }}
                    type="default"
                    icon={<FileAddOutlined />}
                    size="small"
                    disabled={isLoading ? true : false}
                  >
                    Upload Document
                  </Button>
                </Upload>
              </div>
              {filePath?.length > 0 ? (
                <div className="upf-item">
                  <Button type="dashed" size="small">
                    <Tooltip title={filePath}>
                      {filePath?.slice(0, 18) + "..."}
                    </Tooltip>
                    <Tooltip title="Clear">
                      <span
                        className="clear-file"
                        onClick={(e) => setFilePath("")}
                      >
                        <CloseCircleTwoTone
                          twoToneColor="#FF4646"
                          style={{ marginLeft: "5px" }}
                        />
                      </span>
                    </Tooltip>
                  </Button>
                </div>
              ) : null}
              <div className="upf-item" style={{ flex: "1" }}>
                <div className="up-flex-items doc-url">
                  <div className="input-clear">
                    <Input
                      size="small"
                      disabled={collectionSource === "database" || viewOnly}
                      placeholder="Reference Document URL(Optional)"
                      onChange={(e) => {
                        onDocumentURLClick(e.target.value);
                        const index = uploadFileListTemp?.findIndex(
                          (obj) => obj.id === 1
                        );
                        if (index !== -1) {
                          uploadFileListTemp[index].docURL = e.target.value;
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
              {/* <div className="upf-item">
                  <Button
                    type="text"
                    danger
                    icon={<DeleteTwoTone twoToneColor="#FF4646" />}
                  ></Button>
                </div> */}
            </div>
          </div>
          <div className="btn-flex-1 text-center" style={{ marginTop: "10px" }}>
            {isLoading ? (
              <button className="btn btn-primary">
                <div class="sp sp-circle text-light"></div>
              </button>
            ) : (
              <Button
                type="primary"
                size="small"
                className={`${
                  collectionSource === "database" || viewOnly ? "disabled" : ""
                }`}
                style={{
                  pointerEvents:
                    collectionSource === "database" || viewOnly ? "none" : "auto",
                }}
                onClick={(e) => addFile()}
              >
                Submit
              </Button>
            )}
          </div>
        </div>) : null}
          {fileMode === "gdrive" ? (
        <div className="g-drive connect-gs-block">
          <div className="gs-inner-block">
            <div className="input-clear">
                                        <Select
                                          value={fileTypeDefault}
                                          mode="multiple"
                                          allowClear
                                          showArrow="true"
                                          style={{
                                            width: "100%",
                                          }}
                                          placeholder="Select the file type if choosing a folder (Optional)"
                                          onChange={handleChangeFileType}
                                          options={[
                                            {
                                              value: ".pdf",
                                              label: ".pdf",
                                            },
                                            {
                                              value: ".docx",
                                              label: ".docx",
                                            },
                                            {
                                              value: ".xlsx",
                                              label: ".xlsx",
                                            },
                                            {
                                              value: ".pptx",
                                              label: ".pptx",
                                            },
                                          ]}
                                        />
            </div>
            <Button
              className={`${
                collectionSource === "database" || viewOnly ? "disabled" : ""
              }`}
              style={{
                pointerEvents:
                  collectionSource === "database" || viewOnly ? "none" : "auto",
              }}
              onClick={(e) => handleOpenPicker()}
              type="default"
              icon={
                <img
                  src={gdriveIcon}
                  alt="Google Drive"
                  style={{ width: 20, height: 20, marginRight: 10 }}
                />
              }
            >
              Connect Google Drive
            </Button>
          </div>
        </div> ) : null }
                
        {fileMode === "sharepoint" ? (
        <div className="sharepoint connect-gs-block">
          <div className="gs-inner-block">
          <>
          {sharepointLoggedIn ?
          <Button
              className={`${
                collectionSource === "database" || viewOnly ? "disabled" : ""
              }`}
              style={{
                pointerEvents:
                  collectionSource === "database" || viewOnly ? "none" : "auto",
              }}
              onClick={async (e) => {
                await msalInstance.logoutPopup();
                checkForActiveSharepointSession();
              }}
              danger
              icon={<CloseCircleOutlined />}
            >
              Disconnect
            </Button>
           : null}
            <div className="input-clear">
                                        <Select
                                          value={fileTypeDefault}
                                          mode="multiple"
                                          allowClear
                                          showArrow="true"
                                          style={{
                                            width: "100%",
                                          }}
                                          placeholder="Select the file type if choosing a folder (Optional)"
                                          onChange={handleChangeFileType}
                                          options={[
                                            {
                                              value: ".pdf",
                                              label: ".pdf",
                                            },
                                            {
                                              value: ".docx",
                                              label: ".docx",
                                            },
                                            {
                                              value: ".xlsx",
                                              label: ".xlsx",
                                            },
                                            {
                                              value: ".pptx",
                                              label: ".pptx",
                                            },
                                          ]}
                                        />
            </div>
            <Button
              className={`${
                collectionSource === "database" || viewOnly ? "disabled" : ""
              }`}
              style={{
                pointerEvents:
                  collectionSource === "database" || viewOnly ? "none" : "auto",
              }}
              onClick={(e) => handleSharePoint()}
              type="default"
              icon={
                <img
                  src={sharepointIcon}
                  alt="SharePoint"
                  style={{ width: 20, height: 20, marginRight: 10 }}
                />
              }
            >
              {sharepointLoggedIn ? "Browse files" : "Connect to Sharepoint"}
            </Button>
          </>  
          </div>
        </div> ) : null }
      </div>
    </>
  );
};
export default AddLocalFile;
